import { observable, action, ObservableMap } from 'mobx';
import fetch from '../fetch';

class CustomPlaylist {
    @observable
    collection = new ObservableMap();
    @observable
    details = new ObservableMap();

    constructor() {
        this.baseUrl = '/api/customPlaylists';
    }

    @action
    reset = () => {
        this.collection.clear();
        this.details.clear();
    };

    @action.bound
    async listCustomPlaylists() {

        const customPlaylists = await fetch.get({
            url: `/api/customPlaylists`,
        });

        if (customPlaylists && customPlaylists.error)
            return {};

        return customPlaylists;
    };
}

export default new CustomPlaylist();
